// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lz-0";
export var assigneeDetails = "_lz-1";
export var assigneeInfo = "_lz-2";
export var dropdownContainer = "_lz-4";
export var dropdownImage = "_lz-5";
export var editAssigneeInfo = "_lz-3";
export var editAssigneeModalContainer = "_lz-6";
export var hidden = "_lz-8";
export var input = "_lz-7";